import { AIRTIME_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { IAirTimeManagementRepository } from "../domain/repositories/IAirtimeManagementRepository";
import { AirtimeActionRequestModel } from "./model/actions/AirtimeActionRequestModel";
import { AirTimeManagementRequestModel } from "./model/AirtimeManagementRequestModel";
import { AirTimeManagementResponseModel } from "./model/AirtimeManagementResponseModel";
import { AirTimeManagementDetailResponseModel } from "./model/detail/AirtimeManagementDetailResponseModel";

@injectable()
export class AirTimeManagementImpl implements IAirTimeManagementRepository {
  async getList(
    params: AirTimeManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<AirTimeManagementResponseModel>> {
    return await client?.get(AIRTIME_MANAGEMENT.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<AirTimeManagementDetailResponseModel>> {
    return await client?.get(AIRTIME_MANAGEMENT.DETAIL, params);
  }

  async updateAirTime(
    body: AirtimeActionRequestModel,
  ): Promise<BaseApiResponseModel<AirTimeManagementResponseModel>> {
    return await client?.put(AIRTIME_MANAGEMENT.UPDATE, body);
  }

  async createAirTime(
    body: AirtimeActionRequestModel,
  ): Promise<BaseApiResponseModel<AirTimeManagementResponseModel>> {
    return await client?.post(AIRTIME_MANAGEMENT.CREATE, body);
  }

  async deleteAirTime(body: {
    code: string;
  }): Promise<BaseApiResponseModel<AirTimeManagementResponseModel>> {
    return await client?.delete(AIRTIME_MANAGEMENT.DELETE, body);
  }
}
